!function() {
	$("#faq_list .question , .faq_list .question").click(function(){
		if($(this).is(".plus")){
			$(this).next(".asked").slideToggle(200);
			$(this).removeClass("plus");
			$(this).addClass("minus");
			$(this).next(".asked").css('opacity','0');
			$(this).next(".asked").animate({
				opacity:1
			},500);
		}else{
			$(this).next(".asked").slideToggle(200);
			$(this).removeClass("minus");
			$(this).addClass("plus");
		}
	});
}();
